import { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
    const [lang, setLang] = useState(() => localStorage.getItem('venus-lang') || 'en');

    useEffect(() => {
        localStorage.setItem('venus-lang', lang);
        document.documentElement.lang = lang;
    }, [lang]);

    const toggle = () => setLang(l => l === 'en' ? 'es' : 'en');

    return (
        <LanguageContext.Provider value={{ lang, toggle }}>
            {children}
        </LanguageContext.Provider>
    );
}

export function useLanguage() {
    return useContext(LanguageContext);
}
